import React, { useCallback, useEffect, useRef, useState } from 'react'
import FileUploader from 'components/FileUploader'
import TICKETS_API from 'api/tickets/v1'
import { Row } from 'gu-ui-kit'
import styles from 'components/FileUploader/file-uploader.module.scss'
import Ready from 'components/FileUploader/subcomponents/ReadyRow'
import InProgress from 'components/FileUploader/subcomponents/FileRow'
import clsx from 'clsx'

const renderFileUploader = ({
  label,
  disabled = false,
  fields,
  meta: { touched, error, submitFailed, submitting },
  UploadButton,
  buttonId,
  rowClassName = '',
}) => {
  const uploadRows = useRef([])
  const [, setRender] = useState()

  const removeRow = useCallback(
    (uuid) => {
      if (disabled) return

      const curr = [...uploadRows.current]
      const rowIndex = curr.findIndex((f) => f.uuid === uuid)

      fields.forEach((member, index, fields) => {
        if (fields.get(index) === uploadRows.current[rowIndex].id) {
          fields.remove(index)
        }
      })

      curr.splice(rowIndex, 1)
      uploadRows.current = [...curr]
      setRender([])
    },
    [uploadRows.current, disabled, fields],
  )

  const taskUpdate = useCallback(
    (uuid, data) => {
      const currentUploadRows = [...uploadRows.current]
      const index = currentUploadRows.findIndex((row) => row.uuid === uuid)

      currentUploadRows[index] = {
        ...currentUploadRows[index],
        ...data,
      }

      uploadRows.current = currentUploadRows

      if (data.complete) {
        fields.push(data.id)
      }

      setRender([])
    },
    [uploadRows.current],
  )

  useEffect(() => {
    if (fields.length === 0) {
      uploadRows.current = uploadRows.current.filter((row) => !row.complete)
      setRender([])
    }
  }, [fields])

  return (
    <>
      {uploadRows.current.map((file, i) => (
        <Row
          className={clsx(styles['row'], rowClassName)}
          key={'file-row-' + i}
          flexWrap={'nowrap'}
        >
          {file.complete ? (
            <Ready
              {...file}
              remove={() => {
                removeRow(file.uuid)
              }}
            />
          ) : (
            <InProgress
              {...file}
              disabled={disabled}
              remove={() => {
                removeRow(file.uuid)
              }}
            />
          )}
        </Row>
      ))}

      <Row>
        <FileUploader
          buttonId={buttonId}
          UploadButton={UploadButton}
          label={label}
          disabled={submitting || disabled}
          onLoadListUpdate={(newRows) => {
            uploadRows.current = [...uploadRows.current, ...newRows]
            setRender([])
          }}
          onTaskUpdate={taskUpdate}
          uploadFunction={(fileData) => TICKETS_API.upload(fileData)}
        />
      </Row>
      <Row>{(touched || submitFailed) && error && <span>{error}</span>}</Row>
    </>
  )
}

export default renderFileUploader
